module.exports = __webpack_public_path__ + "img/card_大师分排行@2x.37f372e0.png";